import { render, staticRenderFns } from "./InfoAdjustment.vue?vue&type=template&id=76138bc2"
import script from "./InfoAdjustment.vue?vue&type=script&lang=js"
export * from "./InfoAdjustment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports